// extracted by mini-css-extract-plugin
export default {"smGroupGrid":"group-grid_smGroupGrid__4LHIN","lgGroupGrid":"group-grid_lgGroupGrid__Xvl-W","groupImgWrapper":"group-grid_groupImgWrapper__Xk1OC"};